enum CreativeMaxDuration {
  Video = 90,
  Audio = 60,
}

export default CreativeMaxDuration;
